// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tester[data-v-4ac0a0e2] {\n  height: 100%;\n  border: none;\n  margin-top: -80px;\n  position: fixed;\n}\n.fade-enter-active[data-v-4ac0a0e2] {\n  -webkit-transition: all 2s ease;\n  transition: all 2s ease;\n}\n.fade-enter[data-v-4ac0a0e2] {\n  opacity: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
